<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>Human Resources Cluster 🧑‍🤝‍🧑</h1>
        <h4>The Human Resources Cluster is responsible for managing the member and officer recruitment, development, evaluation, and empowerment initiatives and activities of the organization, which help members develop not just their technical skills but also their interpersonal skills.</h4>

        <h3>Positions:</h3>

        <h2><b>Human Resources Project Officer (HRPO)</b></h2>
        <h4> The officer HRPO will be deployed and divided into the following: </h4>
        
        <h3><b>Member Engagement Officers (MEO)</b></h3>
        <h4>Creates and manages various member engagement initiatives for the organization’s members. </h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Tasked to create and manage various member engagement initiatives for the organization’s members</li>
            <li>Responsible in managing and handling the Member Engagement events of MISA (i.e. Halloween Party, Christmas Party, Valentines Special, Summer Blowout) in collaboration with the Marketing Cluster</li>
            <li>Directly coordinates with the Associate Vice President for Member Relations and the Vice President for Human Resources in terms of member engagement</li> 
        </ul>

        <h3><b>Events Project Officers (EPO)</b></h3>
        <h4>Also known as HR Project Officers for the events cluster. They are to be deployed to the different events of MISA such as General Assembly, Networking Night, IM Summit and more.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Also known as HR Project Officers for the events cluster. They are to be deployed to the different events of MISA</li>
            <li>Are in charge of group dynamics and individual consultations for core team bonding and monitoring</li>
            <li>In-charge of handling internal conflicts and problems in the core team and finding proper solutions to them</li>
            <li>In-charge of finding, orienting, and communicating with the event’s external human resources (i.e. hosts, speakers, facilitators and other additional manpower needed for the event)</li>
            <li>Collaborates with the Programs and Logistics officers with the program of the event</li>
            <li>Directly coordinates with the Associate Vice President for Officer Relations, the Vice President for Human Resources, Deputy Project Director and the Associate Vice President for Events Management</li>
        </ul>

        <h3><b>CoLab Officers (CO)</b></h3>
        <h4>Is responsible for the community-based area projects for CoLab and other advocacy projects planned by the AVP for IM Advocacy.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Is responsible for the advocacy-based area projects for CoLab; Handles and attends the online sessions of MISA partners — NSTP and Ateneo Gabay</li>
            <li>Is in-charge of the MISA CoLab’s modules and operations</li>
            <li>Are in charge of assisting the Associate Vice President for IM Advocacy</li>
        </ul>

        <h2><b>MISA Host Pool</b></h2>
        <h4>Officers that will take on the role of emcee/host during either internal or external MISA Events. Applying for this role would entail that you are: </h4>
        <ul>
            <li>Confident in public speaking</li>
            <li>Creative and witty with improvisation </li>
            <li>Willing to be deployed solo or with a partner host</li>
        </ul>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Will be deployed as the Event Host for the different Internal and External Events of MISA</li>
            <li>Communicates with the Project Core team of the event he/she has been deployed to for dry runs</li>
        </ul>
    
        <!-- BETA POSITIONS -->
        <!-- <h2><b>Associate Vice President for IM Advocacy (2)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Spearheads the organization’s information management advocacies and leads CoLab, MISA’s main IM Advocacy initiative</li>
            <li>Organizes and manages the opportunities for members to volunteer, and introduces other service-based efforts in the organization</li>
            <li>Is responsible for the community-based area projects for CoLab</li>
            <li>Is in-charge of planning and coordinating with MISA partners — NSTP, Ateneo Gabay, and other sector based partners, for their area insertions</li>
            <li>Trains, oversees, deploys, and communicates with the CoLab Officers to make the modules and attend the area insertions, and serves as the bridge between them and the Vice President for Human Resources</li>
        </ul>

        <h2><b>Associate Vice President for Officer Relations (2)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Assists the Vice President for Human Resources in managing all officer recruitment standards and processes of the organization</li>
            <li>Assists the Vice President for Human Resources and the different clusters in deploying the core team-related officers of the organization to ensure proper officer development, maintain officer retention, and avoid officer burnout</li>
            <li>Conducts individual consultations and group dynamics with each office/cluster BETA to regularly check up on the well-being of the BETA members</li>
            <li>Conducts post-event individual consultations (in collaboration with the Events Cluster) with core team officers</li>
        </ul>

        <h2><b>Associate Vice President for Member Relations (2)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Assists the Vice President for Human Resources in managing all member recruitment and member engagement efforts of the organization</li>
            <li>Spearheads the family system called MISAyang Samahan (formerly known as the Mentorship Program), which aims to engage members more through a family system</li>
            <li>Conceptualizes different activities (such as team building activities) that will help the members and officers bond and will help create stronger relations within the organization</li>
            <li>Trains, oversees, deploys, and communicates with the Family Heads and Member Engagement Officers of the cluster, and serves as the bridge between them and the Vice President for Human Resources</li>
        </ul> -->

        <!-- FOOTNOTES? -->
        <br>
        <p></p>
    </div>
</template>

<script>
export default {
    name: 'PrimerHR'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>


